<mat-chip-listbox class="flex w-full min-w-0 flex-wrap gap-4">
  @for (
    term of searchParams | searchTerms : paramLabelMap : combineDateRange;
    track term.key
  ) {
    <mat-chip class="search-chip max-w-full min-w-0 text-sm">
      <div class="flex min-w-0 max-w-full items-center gap-1">
        <div class="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
          <div class="shrink-0">{{ term.name }}:</div>
          <div class="min-w-0 flex-1 truncate font-bold">
            {{ displayValue(term.value) }}
          </div>
        </div>
        @if (!term.disabled) {
          <button
            mat-icon-button
            class="search-chip-remove shrink-0"
            (click)="remove(term)"
            [disabled]="disabled"
            [attr.aria-label]="'Remove ' + term.name"
          >
            <mat-icon
              [svgIcon]="'heroicons_solid:x-circle'"
              class="icon-size-5 !m-0 !flex !h-5 !w-5 !items-center !justify-center !p-0 !leading-none [&>svg]:block"
            ></mat-icon>
          </button>
        }
      </div>
    </mat-chip>
  }
</mat-chip-listbox>
